var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/paging";
import * as authorization from "../../lib/authorization";
import './tipsList.css';
import '../../lib/knockout_datePicker';
import "../../components/tree";
import page from 'page';
import '../../lib/knockout_fileUpload';
import schedule from "../../assets/js/schedule.js";
var Schedule = schedule;
var tipsList = /** @class */ (function (_super) {
    __extends(tipsList, _super);
    function tipsList(root) {
        var _this = _super.call(this, '/api/message/send', root, { pageIndex: 1, userId: authorization.getUserId(), type: '0' }) || this;
        _this.showSend = ko.observable(true); //已发送
        _this.showArchieve = ko.observable(false); //已收取
        return _this;
    }
    // 切换url
    tipsList.prototype.changeUrl = function (d, r) {
        console.log(d, r);
        if (d == '已接收') {
            this.showSend(false); //已发送
            this.showArchieve(true); //已收取
            this.data.pageIndex = 1;
            this.data.type = '1';
        }
        else {
            this.showSend(true); //已发送
            this.showArchieve(false); //已收取
            this.data.pageIndex = 1;
            this.data.type = '0';
        }
        this.loadData();
    };
    // 查看提醒详情
    tipsList.prototype.checkInfo = function (d, r) {
        console.log(d, r);
        page('/home/tipsInfo?id=' + d.id);
    };
    return tipsList;
}(KnockoutModel));
var DemoModel = /** @class */ (function (_super) {
    __extends(DemoModel, _super);
    function DemoModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoModel.prototype.init = function () {
        this.vm = new tipsList(this.container.querySelector('.tipsList'));
        this.vm.bind();
    };
    DemoModel.prototype.update = function (arg) {
        this.vm.loadData();
        return Promise.resolve();
    };
    DemoModel.prototype.onInitComplete = function () {
        // let that = this;
        // var mySchedule = new Schedule({
        //   el: "#schedule-box",
        //   clickCb: function(y: any, m: any, d: any) {
        //     // if(d<10){
        //     //   d='0'+d;
        //     // }
        //     // if(m<10){
        //     //   m='0'+m;
        //     // }
        //     // that.rm.today(y + "-" + m + "-" + d);
        //     // that.vm.today(y + "-" + m + "-" + d);
        //     // that.rm.todaymetting();
        //   }
        // });
    };
    return DemoModel;
}(Page));
export default DemoModel;
